// src/components/DemoGate.jsx
import React, { useEffect, useState } from "react";
import "./DemoGate.css";
import { DEFAULT_ORG_ID, getOrgBrandAssets } from "../utils/brandAssets";

const STORAGE_KEY = "nia_demo_ok";
const USER = process.env.REACT_APP_DEMO_USER || "";
const PASS = process.env.REACT_APP_DEMO_PASS || "";

// If no creds configured, gate is disabled
const GATE_ENABLED = USER && PASS;

export default function DemoGate({ children }) {
  const [ok, setOk] = useState(false);
  const [u, setU] = useState("");
  const [p, setP] = useState("");

  useEffect(() => {
    if (!GATE_ENABLED) {
      setOk(true);
      return;
    }
    const flag = localStorage.getItem(STORAGE_KEY);
    if (flag === "1") setOk(true);
  }, []);

  if (!GATE_ENABLED || ok) return children;
  const assets = getOrgBrandAssets(DEFAULT_ORG_ID, "light");

  const submit = (e) => {
    e.preventDefault();
    if (u.trim() === USER && p.trim() === PASS) {
      localStorage.setItem(STORAGE_KEY, "1");
      setOk(true);
    } else {
      alert("Incorrect demo credentials.");
    }
  };

  return (
    <div className="dg-wrap">
      <div className="dg-card">
        <div className="dg-brand">
          <img src={assets.iconUrl} alt="Nia COACH" />
          <div>
            <h1 style={{margin:0}}>NEUROGRES™ Coach — Demo</h1>
            <div className="dg-sub">This demo is temporarily restricted. Sign in to continue.</div>
          </div>
        </div>

        <form onSubmit={submit} className="dg-form" style={{gridTemplateColumns: "1fr 1fr auto"}}>
          <input
            type="text"
            placeholder="Username"
            value={u}
            onChange={(e) => setU(e.target.value)}
            autoFocus
          />
          <input
            type="password"
            placeholder="Password"
            value={p}
            onChange={(e) => setP(e.target.value)}
          />
          <button type="submit">Unlock</button>
        </form>

        <p className="dg-foot">Need access? Contact the demo owner.</p>
      </div>
    </div>
  );
}
